var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.874 31C19.6954 30.3079 19.3347 29.6762 18.8292 29.1708C18.3238 28.6653 17.6921 28.3046 17 28.126L4.73 24.962C4.52066 24.9026 4.33642 24.7765 4.20522 24.6029C4.07403 24.4293 4.00305 24.2176 4.00305 24C4.00305 23.7824 4.07403 23.5707 4.20522 23.3971C4.33642 23.2235 4.52066 23.0974 4.73 23.038L17 19.872C17.6919 19.6936 18.3234 19.3331 18.8288 18.8281C19.3342 18.323 19.6951 17.6918 19.874 17L23.038 4.73C23.0968 4.51984 23.2228 4.33468 23.3966 4.20279C23.5705 4.07089 23.7828 3.9995 24.001 3.9995C24.2192 3.9995 24.4315 4.07089 24.6054 4.20279C24.7792 4.33468 24.9052 4.51984 24.964 4.73L28.126 17C28.3046 17.6921 28.6653 18.3238 29.1708 18.8292C29.6762 19.3347 30.3079 19.6954 31 19.874L43.27 23.036C43.481 23.0942 43.6671 23.22 43.7997 23.3942C43.9323 23.5683 44.0041 23.7811 44.0041 24C44.0041 24.2189 43.9323 24.4317 43.7997 24.6058C43.6671 24.78 43.481 24.9058 43.27 24.964L31 28.126C30.3079 28.3046 29.6762 28.6653 29.1708 29.1708C28.6653 29.6762 28.3046 30.3079 28.126 31L24.962 43.27C24.9032 43.4802 24.7772 43.6653 24.6034 43.7972C24.4295 43.9291 24.2172 44.0005 23.999 44.0005C23.7808 44.0005 23.5685 43.9291 23.3946 43.7972C23.2208 43.6653 23.0948 43.4802 23.036 43.27L19.874 31Z",
    stroke: "var(--stroke-0, #D4A5A5)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40 6V14",
    stroke: "var(--stroke-0, #D4A5A5)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44 10H36",
    stroke: "var(--stroke-0, #D4A5A5)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8 34V38",
    stroke: "var(--stroke-0, #D4A5A5)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10 36H6",
    stroke: "var(--stroke-0, #D4A5A5)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingIcon);
export default __webpack_public_path__ + "static/media/upcoming-icon.a2da7efc05246fa865bf5467b685262f.svg";
export { ForwardRef as ReactComponent };